import './assets/styles/base.css';
import './assets/styles/modules/hero.css';
import './assets/styles/modules/button.css';
import './assets/styles/modules/validation.css';
import './assets/styles/modules/alert.css';
import './assets/styles/modules/forms.css';
import './assets/styles/modules/loader.css';

import './polyfills';
import angular from 'angular';
import channel from './components/channel';
import header from './components/header';

angular.module('app', [channel, header]);
angular.element(document).ready(() => {
    angular.bootstrap(document, ['app'], { strictDi: true });
});
